document.addEventListener('DOMContentLoaded', function () {
	function initFittedSheetColorFilter() {
		const selectedVariant = document
			.querySelector('.variant-picker-list-Size label.selected')
			?.innerText.trim()
			.replaceAll(' ', '-')
			.toLowerCase();
		const optionLis = document.querySelectorAll(
			'.customoptions--bedsheet .options ul li'
		);
		optionLis.forEach((li) => {
			li.style.display =
				li.getAttribute('data-variant') === selectedVariant ? 'block' : 'none';
		});

		const firstAvailable = Array.from(optionLis).find(
			(li) =>
				li.style.display === 'block' &&
				li.getAttribute('data-inventory') !== '0' &&
				!li.classList.contains('sold-out-variant')
		);
		if (firstAvailable) {
			optionLis.forEach((li) => li.classList.remove('active'));
			firstAvailable.classList.add('active');
			document.querySelector(
				'.customoptions--bedsheet .color_title .color'
			).innerText = firstAvailable.innerText;
		}

		Array.from(optionLis)
			.filter((li) => li.style.display === 'block')
			.forEach((variant) => {
				variant.addEventListener('click', () => {
					Array.from(optionLis).forEach((v) => v.classList.remove('active'));
					variant.classList.add('active');
					document.querySelector(
						'.customoptions--bedsheet .color_title .color'
					).innerText = variant.innerText;
				});
			});
	}
	function initFittedDuvetCoverFilter() {
		const selectedVariant = document
			.querySelector('.variant-picker-list-Size label.selected')
			?.innerText.trim()
			.replaceAll(' ', '-')
			.toLowerCase();
		const optionLis = document.querySelectorAll(
			'.customoptions--duvet .options ul li'
		);

		optionLis.forEach((li) => {
			li.style.display =
				li.getAttribute('data-variant') === selectedVariant ? 'block' : 'none';
		});

		const firstAvailable = Array.from(optionLis).find(
			(li) =>
				li.style.display === 'block' &&
				li.getAttribute('data-inventory') !== '0' &&
				!li.classList.contains('sold-out-variant')
		);
		if (firstAvailable) {
			optionLis.forEach((li) => li.classList.remove('active'));
			firstAvailable.classList.add('active');
			document.querySelector(
				'.customoptions--duvet .color_title .color'
			).innerText = firstAvailable.innerText;
		}

		Array.from(optionLis)
			.filter((li) => li.style.display === 'block')
			.forEach((variant) => {
				variant.addEventListener('click', () => {
					Array.from(optionLis).forEach((v) => v.classList.remove('active'));
					variant.classList.add('active');
					document.querySelector(
						'.customoptions--duvet .color_title .color'
					).innerText = variant.innerText;
				});
			});
	}
	initFittedSheetColorFilter();

	if (window.location.pathname === '/products/custom-bedding-set-complete') {
		initFittedDuvetCoverFilter();
	}

	function initSimpleColorPicker(wrapper, badgeSelector) {
		if (!wrapper) return;
		const badge = wrapper.querySelector(badgeSelector);
		const options = Array.from(wrapper.querySelectorAll('.options ul li'));
		options.forEach((option) => {
			option.addEventListener('click', () => {
				options.forEach((v) => v.classList.remove('active'));
				option.classList.add('active');
				badge.innerText = option.innerText;
			});
		});
	}

	// embroidery toggle helper
	function embroideryToggle(checkbox, details) {
		if (!checkbox || !details) return;

		checkbox.addEventListener('change', () => {
			details.style.display = checkbox.checked ? 'block' : 'none';
		});
	}

	// embroidery dropdown helper
	function embroideryDropdown(dropdown) {
		if (!dropdown) return;
		dropdown.addEventListener('click', function (e) {
			if (e.target.tagName === 'LI') {
				dropdown.prepend(e.target);
			}
			dropdown.classList.toggle('open');
		});
	}

	initSimpleColorPicker(
		document.querySelector('.custom--iced-bamboo-bolster-case'),
		'.color_title .color'
	);
	initSimpleColorPicker(
		document.querySelector('.custom--iced-bamboo-bolster-case-1'),
		'.color_title .color'
	);
	initSimpleColorPicker(
		document.querySelector('.customoptions--iced-bamboo-pillow-case-1'),
		'.color_title .color'
	);
	initSimpleColorPicker(
		document.querySelector('.customoptions--iced-bamboo-pillow-case-2'),
		'.color_title .color'
	);
	initSimpleColorPicker(
		document.querySelector('.customoptions--iced-bamboo-pillow-case-3'),
		'.color_title .color'
	);
	initSimpleColorPicker(
		document.querySelector('.customoptions--iced-bamboo-pillow-case-4'),
		'.color_title .color'
	);

	embroideryToggle(
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 input[type="checkbox"]'
		),
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 div'
		)
	);
	embroideryDropdown(
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 ul'
		)
	);

	embroideryToggle(
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .option-embroidery-wrap input[type="checkbox"]'
		),
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .cl-option-embroideryCase1'
		)
	);
	embroideryDropdown(
		document.querySelector(
			'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .cl-option-embroideryCase1 ul'
		)
	);
	embroideryToggle(
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-3 .option-embroidery-wrap input[type="checkbox"]'
		),
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-3 .cl-option-embroideryCase3'
		)
	);
	embroideryDropdown(
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-3 .cl-option-embroideryCase3 ul'
		)
	);
	embroideryToggle(
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-4 .option-embroidery-wrap input[type="checkbox"]'
		),
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-4 .cl-option-embroideryCase4'
		)
	);
	embroideryDropdown(
		document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-4 .cl-option-embroideryCase4 ul'
		)
	);

	const bolsterCheckbox = document.querySelector(
		'.custom--iced-bamboo-bolster-case input[type="checkbox"]'
	);
	const bolsterCase = document.querySelector(
		'.custom--iced-bamboo-bolster-case'
	);
	const pillowCase2 = document.querySelector(
		'.customoptions--iced-bamboo-pillow-case-2'
	);
	const pillowCase2Checkbox = pillowCase2?.querySelector(
		'input[type="checkbox"]'
	);

	function switchBolsterPillow() {
		if (!bolsterCheckbox || !pillowCase2Checkbox) return;

		bolsterCheckbox.addEventListener('change', () => {
			if (bolsterCheckbox.checked) {
				bolsterCase.style.display = 'none';
				pillowCase2.style.display = 'block';
				pillowCase2Checkbox.checked = false;
			} else {
				bolsterCase.style.display = 'block';
				pillowCase2.style.display = 'none';
			}
		});

		pillowCase2Checkbox.addEventListener('change', () => {
			if (pillowCase2Checkbox.checked) {
				bolsterCase.style.display = 'block';
				pillowCase2Checkbox.checked = false;
				bolsterCheckbox.checked = false;

				pillowCase2.style.display = 'none';
			}
		});
	}
	function switchBolstersPillows() {
		const pillowCaseCheckboxChangeToBolsterCase = document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-2 .option-pillowcase2 '
		);
		const pillowCase2Checkbox = pillowCase2?.querySelector(
			'input[type="checkbox"]'
		);

		pillowCase2Checkbox.checked = false;
		pillowCaseCheckboxChangeToBolsterCase.remove();

		const bolsterCheckbox = document.querySelector(
			'.custom--iced-bamboo-bolster-case input[type="checkbox"]'
		);
		const bolsterCase = document.querySelector(
			'.custom--iced-bamboo-bolster-case'
		);
		const pillowCase3 = document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-3'
		);
		const pillowCase3Checkbox = pillowCase3?.querySelector(
			'input[type="checkbox"]'
		);
		const bolsterCheckbox1 = document.querySelector(
			'.custom--iced-bamboo-bolster-case-1 input[type="checkbox"]'
		);
		const bolsterCase1 = document.querySelector(
			'.custom--iced-bamboo-bolster-case-1'
		);
		const pillowCase4 = document.querySelector(
			'.customoptions--iced-bamboo-pillow-case-4'
		);
		const pillowCase4Checkbox = pillowCase4?.querySelector(
			'input[type="checkbox"]'
		);

		if (!bolsterCheckbox || !pillowCase3Checkbox) return;

		bolsterCheckbox.addEventListener('change', () => {
			if (bolsterCheckbox.checked) {
				bolsterCase.style.display = 'none';
				pillowCase3.style.display = 'block';
				pillowCase3Checkbox.checked = false;
			} else {
				bolsterCase.style.display = 'block';
				pillowCase3.style.display = 'none';
			}
		});

		pillowCase3Checkbox.addEventListener('change', () => {
			if (pillowCase3Checkbox.checked) {
				bolsterCase.style.display = 'block';
				pillowCase3Checkbox.checked = false;
				bolsterCheckbox.checked = false;

				pillowCase3.style.display = 'none';
			}
		});
		if (!bolsterCheckbox1 || !pillowCase4Checkbox) return;

		bolsterCheckbox1.addEventListener('change', () => {
			if (bolsterCheckbox1.checked) {
				bolsterCase1.style.display = 'none';
				pillowCase4.style.display = 'block';
				pillowCase4Checkbox.checked = false;
			} else {
				bolsterCase1.style.display = 'block';
				pillowCase3.style.display = 'none';
			}
		});

		pillowCase4Checkbox.addEventListener('change', () => {
			if (pillowCase4Checkbox.checked) {
				bolsterCase1.style.display = 'block';
				pillowCase4Checkbox.checked = false;
				bolsterCheckbox1.checked = false;

				pillowCase4.style.display = 'none';
			}
		});
	}
	const v = document
		.querySelector('.variant-picker-list-Size label.selected')
		?.innerText.trim()
		.replaceAll(' ', '-')
		.toLowerCase();

	if (['single', 'super-single'].includes(v)) {
		switchBolsterPillow();
	} else if (['queen', 'king'].includes(v)) {
		switchBolstersPillows();
	}

	function handleVariantDisplay() {
		const [
			bolsterCase1,
			bolsterCase2,
			pillowCase1,
			pillowCase2,
			pillowCase3,
			pillowCase4,
		] = [
			'.custom--iced-bamboo-bolster-case-1',
			'.custom--iced-bamboo-bolster-case-2',
			'.customoptions--iced-bamboo-pillow-case-1',
			'.customoptions--iced-bamboo-pillow-case-2',
			'.customoptions--iced-bamboo-pillow-case-3',
			'.customoptions--iced-bamboo-pillow-case-4',
		].map((s) => document.querySelector(s));
		if (['single', 'super-single'].includes(v)) {
			[
				bolsterCase1,
				bolsterCase2,
				pillowCase2,
				pillowCase3,
				pillowCase4,
			].forEach((e) => e && (e.style.display = 'none'));
			if (pillowCase1) pillowCase1.style.display = 'block';
		} else if (['queen', 'king'].includes(v)) {
			[bolsterCase1, pillowCase1, pillowCase2].forEach(
				(e) => e && (e.style.display = 'block')
			);
			[bolsterCase2, pillowCase3, pillowCase4].forEach(
				(e) => e && (e.style.display = 'none')
			);
		}
	}
	handleVariantDisplay();

	function createHiddenInput(id, name, value) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.id = id;
		input.name = name;
		input.value = value;
		return input;
	}

	document
		.querySelector('.product-form__btn')
		.addEventListener('click', function () {
			const form = document.querySelector('.product-form');
			if (!form) return;

			form
				.querySelectorAll('input[id^="customoptions--"], input[id^="custom--"]')
				.forEach((e) => e.remove());

			const inputs = [];

			if (['single', 'super-single'].includes(v)) {
				// Fitted sheet
				const fittedSheetColor = document.querySelector(
					'.customoptions--bedsheet .color_title .color'
				).innerText;
				inputs.push(
					createHiddenInput(
						'customoptions--bedsheet',
						'properties[Iced Bamboo Fitted Sheet]',
						fittedSheetColor
					)
				);

				//Duvet Cover
				if (
					window.location.pathname === '/products/custom-bedding-set-complete'
				) {
					const fittedSheetColor = document.querySelector(
						'.customoptions--duvet .color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--duvet',
							'properties[Iced Bamboo Duvet Cover]',
							fittedSheetColor
						)
					);
				}

				// Pillow Case 1
				const pillow1Color = document.querySelector(
					'.customoptions--iced-bamboo-pillow-case-1 .color_title .color'
				).innerText;
				inputs.push(
					createHiddenInput(
						'customoptions--iced-bamboo-pillow-case-1',
						'properties[Iced Bamboo Pillow Case 1]',
						pillow1Color
					)
				);

				// Pillow Case 1 embroidery
				const pillowCase1EmbCheckbox = document.querySelector(
					'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 input[type="checkbox"]'
				);
				if (pillowCase1EmbCheckbox && pillowCase1EmbCheckbox.checked) {
					const font1 =
						document.querySelector(
							'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 ul li:first-child'
						)?.innerText || '';
					const text1 =
						document.querySelector(
							'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-1 .option_textbox input'
						)?.value || '';
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-1-font',
							'properties[Embroidery Font 1]',
							font1
						)
					);
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-1-text',
							'properties[Embroidery Text 1]',
							text1
						)
					);
				}

				// Pillow Case 2 vs Bolster
				const bolsterCheckbox = document.querySelector(
					'.custom--iced-bamboo-bolster-case input[type="checkbox"]'
				);
				if (bolsterCheckbox && bolsterCheckbox.checked) {
					// Pillow Case 2
					const pillow2Color = document.querySelector(
						'.customoptions--iced-bamboo-pillow-case-2 .color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-2',
							'properties[Iced Bamboo Pillow Case 2]',
							pillow2Color
						)
					);
					// Pillow Case 2 embroidery
					const pillowCase2EmbCheckbox = document.querySelector(
						'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .option-embroidery-wrap input[type="checkbox"]'
					);
					if (pillowCase2EmbCheckbox && pillowCase2EmbCheckbox.checked) {
						const font2 =
							document.querySelector(
								'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .cl-option-embroideryCase1 ul li:first-child'
							)?.innerText || '';
						const text2 =
							document.querySelector(
								'.pillowcase-checkbox.customoptions--iced-bamboo-pillow-case-2 .cl-option-embroideryCase1 .option_textbox input'
							)?.value || '';
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-2-font',
								'properties[Embroidery Font 2]',
								font2
							)
						);
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-2-text',
								'properties[Embroidery Text 2]',
								text2
							)
						);
					}
				} else {
					// Bolster Case
					const bolsterColor = document.querySelector(
						'.custom--iced-bamboo-bolster-case .color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'custom--iced-bamboo-bolster-case',
							'properties[Iced Bamboo Bolster Case 1]',
							bolsterColor
						)
					);
				}

				inputs.forEach((input) => form.appendChild(input));

				setTimeout(() => {
					form.addEventListener('submit', function () {
						form
							.querySelectorAll(
								'input[id^="customoptions--"], input[id^="custom--"]'
							)
							.forEach((input) => input.remove());
					});
				}, 2000);
			} else if (['queen', 'king'].includes(v)) {
				// Fitted Sheet
				const fittedSheetColor = document.querySelector(
					'.customoptions--bedsheet .color_title .color'
				).innerText;
				inputs.push(
					createHiddenInput(
						'customoptions--bedsheet',
						'properties[Iced Bamboo Fitted Sheet]',
						fittedSheetColor
					)
				);

				if (
					window.location.pathname === '/products/custom-bedding-set-complete'
				) {
					const fittedSheetColor = document.querySelector(
						'.customoptions--duvet .color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--duvet',
							'properties[Iced Bamboo Duvet Cover]',
							fittedSheetColor
						)
					);
				}

				const pillow1Section = document.querySelector(
					'.customoptions--iced-bamboo-pillow-case-1'
				);
				if (pillow1Section && pillow1Section.style.display !== 'none') {
					const pillow1Color = pillow1Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-1',
							'properties[Iced Bamboo Pillow Case 1]',
							pillow1Color
						)
					);

					const pillow1EmbCheckbox = pillow1Section.querySelector(
						'.option-embroidery-wrap input[type="checkbox"]'
					);
					if (pillow1EmbCheckbox && pillow1EmbCheckbox.checked) {
						const font1 =
							pillow1Section.querySelector(
								'.cl-option-embroideryCase ul li:first-child'
							)?.innerText || '';
						const text1 =
							pillow1Section.querySelector(
								'.cl-option-embroideryCase .option_textbox input'
							)?.value || '';
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-1-font',
								'properties[Embroidery Font 1]',
								font1
							)
						);
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-1-text',
								'properties[Embroidery Text 1]',
								text1
							)
						);
					}
				}

				const pillow2Section = document.querySelector(
					'.customoptions--iced-bamboo-pillow-case-2'
				);
				if (pillow2Section && pillow2Section.style.display !== 'none') {
					const pillow2Color = pillow2Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-2',
							'properties[Iced Bamboo Pillow Case 2]',
							pillow2Color
						)
					);

					const pillow2EmbCheckbox = pillow2Section.querySelector(
						'.option-embroidery-wrap input[type="checkbox"]'
					);

					if (pillow2EmbCheckbox && pillow2EmbCheckbox.checked) {
						const font2 =
							pillow2Section.querySelector(
								'.cl-option-embroideryCase1 ul li:first-child'
							)?.innerText || '';
						const text2 =
							pillow2Section.querySelector(
								'.cl-option-embroideryCase1 .option_textbox input'
							)?.value || '';

						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-2-font',
								'properties[Embroidery Font 2]',
								font2
							)
						);
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-2-text',
								'properties[Embroidery Text 2]',
								text2
							)
						);
					}
				}

				const bolster1Checkbox = document.querySelector(
					'.custom--iced-bamboo-bolster-case input[type="checkbox"]'
				);
				const pillow3Section = document.querySelector(
					'.customoptions--iced-bamboo-pillow-case-3'
				);
				const bolster1Section = document.querySelector(
					'.custom--iced-bamboo-bolster-case'
				);
				if (
					bolster1Checkbox &&
					bolster1Checkbox.checked &&
					pillow3Section &&
					pillow3Section.style.display !== 'none'
				) {
					const pillow3Color = pillow3Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-3',
							'properties[Iced Bamboo Pillow Case 3]',
							pillow3Color
						)
					);

					const pillow3EmbCheckbox = pillow3Section.querySelector(
						'.option-embroidery-wrap input[type="checkbox"]'
					);
					if (pillow3EmbCheckbox && pillow3EmbCheckbox.checked) {
						const font3 =
							pillow3Section.querySelector(
								'.cl-option-embroideryCase3 ul li:first-child'
							)?.innerText || '';
						const text3 =
							pillow3Section.querySelector(
								'.cl-option-embroideryCase3 .option_textbox input'
							)?.value || '';
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-3-font',
								'properties[Embroidery Font 3]',
								font3
							)
						);
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-3-text',
								'properties[Embroidery Text 3]',
								text3
							)
						);
					}
				} else if (
					bolster1Section &&
					bolster1Section.style.display !== 'none'
				) {
					const bolster1Color = bolster1Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'custom--iced-bamboo-bolster-case',
							'properties[Iced Bamboo Bolster Case 1]',
							bolster1Color
						)
					);
				}

				const bolster2Checkbox = document.querySelector(
					'.custom--iced-bamboo-bolster-case-1 input[type="checkbox"]'
				);
				const pillow4Section = document.querySelector(
					'.customoptions--iced-bamboo-pillow-case-4'
				);
				const bolster2Section = document.querySelector(
					'.custom--iced-bamboo-bolster-case-1'
				);

				if (bolster2Checkbox && bolster2Checkbox.checked) {
					const pillow4Color = pillow4Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'customoptions--iced-bamboo-pillow-case-4',
							'properties[Iced Bamboo Pillow Case 4]',
							pillow4Color
						)
					);

					const pillow4EmbCheckbox = pillow4Section.querySelector(
						'.option-embroidery-wrap input[type="checkbox"]'
					);
					if (pillow4EmbCheckbox && pillow4EmbCheckbox.checked) {
						const font4 =
							pillow4Section.querySelector(
								'.cl-option-embroideryCase4 ul li:first-child'
							)?.innerText || '';
						const text4 =
							pillow4Section.querySelector(
								'.cl-option-embroideryCase4 .option_textbox input'
							)?.value || '';
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-4-font',
								'properties[Embroidery Font 4]',
								font4
							)
						);
						inputs.push(
							createHiddenInput(
								'customoptions--iced-bamboo-pillow-case-4-text',
								'properties[Embroidery Text 4]',
								text4
							)
						);
					}
				} else if (
					bolster2Section &&
					bolster2Section.style.display !== 'none'
				) {
					const bolster2Color = bolster2Section.querySelector(
						'.color_title .color'
					).innerText;
					inputs.push(
						createHiddenInput(
							'custom--iced-bamboo-bolster-case-1',
							'properties[Iced Bamboo Bolster Case 2]',
							bolster2Color
						)
					);
				}

				inputs.forEach((input) => form.appendChild(input));

				setTimeout(() => {
					form.addEventListener('submit', function () {
						form
							.querySelectorAll(
								'input[id^="customoptions--"], input[id^="custom--"]'
							)
							.forEach((input) => input.remove());
					});
				}, 2000);
			}
		});
});
